module.exports = __webpack_public_path__ + "static/media/car.9a12e482.svg";